const QQ_APPID = '101929290'
// const WX_APPID = 'wxe9437a33c181f117'
// 易行东方
// const WX_APPID = 'wx1707fa10fb8802f2'
// 深圳金钥匙
const WX_APPID = 'wx0c92b7c48b9d2269'

const domain = 'https://wap.ys141319.com'

const apidomain = domain
const H5_domain = domain + '/h5'
const WX_REDIRECT_URI = H5_domain
const QQ_REDIRECT_URI = H5_domain

export default {
  domain,
  apidomain,
  H5_domain,
  WX_APPID,
  QQ_APPID,
  WX_REDIRECT_URI,
  QQ_REDIRECT_URI
}